export default "__VITE_ASSET__Dw4B63Vn__"